// Mock data for Send My Parcel

export const carriers = [
  {
    id: 1,
    name: "Send My Parcel Network",
    logo: "/assets/images/whitebglogo.jpeg",
    services: ["Domestic", "International", "Express"]
  },
  {
    id: 2,
    name: "DHL Express",
    logo: "/assets/images/carriers/dhl.png",
    services: ["Express Delivery", "Same Day", "International"]
  },
  {
    id: 3,
    name: "FedEx",
    logo: "/assets/images/carriers/fedex.png",
    services: ["Overnight", "Express", "Ground"]
  },
  {
    id: 4,
    name: "UPS",
    logo: "/assets/images/carriers/ups.png",
    services: ["Next Day", "Express", "Standard"]
  },
  {
    id: 6,
    name: "Aramex",
    logo: "/assets/images/carriers/arame.png",
    services: ["Express", "Logistics", "International"]
  },
  {
    id: 2,
    title: "International Express",
    subtitle: "Worldwide - Starting from ₹200",
    description: "Express international delivery to 190+ countries with customs clearance support",
    features: ["Express Delivery", "Customs Support", "Door-to-Door", "Live Tracking"],
    price: "Starting ₹200",
    deliveryTime: "3-7 Business Days",
    icon: "✈️"
  },
  {
    id: 3,
    title: "Large & Heavy Parcels",
    subtitle: "Oversized Items - Starting from ₹120",
    description: "Specialized handling for large, heavy, and oversized parcels with freight options",
    features: ["Freight Services", "Special Handling", "Pallet Shipping", "White Glove Service"],
    price: "Starting ₹120",
    deliveryTime: "2-5 Business Days",
    icon: "📦"
  }
];


export const features = [
  {
    id: 1,
    title: "Multi-Carrier Network",
    description: "Compare rates from 15+ premium carriers including DHL, FedEx, UPS, and local partners",
    icon: "Network"
  },
  {
    id: 2,
    title: "Real-Time Tracking",
    description: "Track your shipments in real-time with SMS and email notifications at every step",
    icon: "MapPin"
  },
  {
    id: 3,
    title: "Customs Support",
    description: "Complete customs documentation and clearance support for international shipments",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Secure Payments",
    description: "Multiple payment options including UPI, credit/debit cards, and net banking",
    icon: "CreditCard"
  },
  {
    id: 6,
    title: "Business Solutions",
    description: "Dedicated account management and volume discounts for businesses and enterprises",
    icon: "Building"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Get Quote",
    description: "Enter shipment details and get instant quotes from multiple carriers",
    icon: "Calculator"
  },
  {
    step: 2,
    title: "Book & Pay",
    description: "Select your preferred service and pay securely online",
    icon: "CreditCard"
  },
  {
    step: 3,
    title: "Schedule Pickup",
    description: "Schedule convenient pickup from your location or drop at nearby center",
    icon: "Clock"
  },
  {
    step: 4,
    title: "Track Delivery",
    description: "Monitor your shipment with real-time tracking and updates",
    icon: "MapPin"
  }
];

export const pricingData = [
  {
    carrier: "DHL Express",
    domestic: "₹89",
    international: "₹1,250",
    deliveryTime: "1-2 days",
    rating: 4.8
  },
  {
    carrier: "FedEx",
    domestic: "₹95",
    international: "₹1,180",
    deliveryTime: "1-3 days", 
    rating: 4.7
  },
  {
    carrier: "UPS",
    domestic: "₹85",
    international: "₹1,320",
    deliveryTime: "2-3 days",
    rating: 4.6
  },
  {
    carrier: "Blue Dart",
    domestic: "₹65",
    international: "₹980",
    deliveryTime: "1-2 days",
    rating: 4.5
  }
];

export const supportData = {
  phone: "011-47501136",
  email: "contact@sendmyparcel.in",
  whatsapp: "9821984141",
  address: "Madhuban Tower, A-200 Road no 4, Gali no 10, Mahipalpur, New Delhi 110037",
  hours: "Mon-Sat: 9 AM - 7 PM IST"
};